import { useNavigate } from "react-router-dom";

const LogoComponent = (props: any) => {
    const navigate = useNavigate();

    const navigateTo = (location: string) => {
        navigate(location);
    }

    return (
        <div className="align-center logo-comp">
            {props.logoColor && props.logoColor === "white" ? (
                <img onClick={() => navigateTo('/')} className="kate-logo" src="./img/Logo-white.png" alt="logo" />

            ) : (
                <img onClick={() => navigateTo('/')} className="kate-logo" src="./img/Logo1.png" alt="logo" />
            )}
        </div>
    )
}

export default LogoComponent;